import numbro from 'numbro';

export const num = (input: any) => numbro(input);

export const add = (a: number, b: number) => numbro(a).add(b).value();

export const subtract = (a: number, b: number) => numbro(a).subtract(b).value();

export const multiply = (a: number, b: number) => numbro(a).multiply(b).value();

export const divide = (a: number, b: number) => numbro(a).divide(b).value();

export const sum = (...args: number[]) => {
    const result = numbro(0);
    args.forEach((num) => result.add(num));
    return result.value();
};

export const sumBy = <T>(array: readonly T[], iteratee: (item: T) => number) => {
    let result: numbro.Numbro | undefined;

    array.forEach((item) => {
        const value = iteratee(item);

        if (result === undefined) {
            result = numbro(value);
        } else {
            result.add(value);
        }
    });

    return result?.value() ?? 0;
};
